const SOURCE_TYPE = '02'
const WORK_WX = '01'
const WX = '02'
const OT = '03'
let APP_TYPE = null

const ua = window.navigator.userAgent.toLowerCase()
if (ua.match(/micromessenger/i) == 'micromessenger' && (ua.match(/wxwork/i) == 'wxwork')) {
    APP_TYPE = WORK_WX
} else if (ua.match(/micromessenger/i) == 'micromessenger') {
    APP_TYPE = WX
} else {
    APP_TYPE = OT
}

module.exports = { SOURCE_TYPE, WORK_WX, WX, OT, APP_TYPE }
